import React from 'react';

const styles = {
  welcomeText: {
    fontFamily: "'Helvetica Neue', Helvetica, Arial",
    fontSize: '11px',
    fontStyle: 'oblique',
    lineHeight: 1.36,
    color: '#999999',
  },
};

const WelcomeName = props => (
  <div style={styles.welcomeText}>
    Welcome, {props.text}
  </div>
);

export default WelcomeName;



// WEBPACK FOOTER //
// ./src/app/components/Header/DesktopHeader/WelcomeName.js